import React, { useState, useEffect } from 'react'
import DEFAULT_TOKEN_LIST from '@ixswap1/default-token-list'
import styled from 'styled-components'

import { isAddress } from '../../hooks/lists'
import EthereumLogo from '../../assets/eth.png'
import { usedChain, WETH } from '../../constants/index.js'
import { listToTokenMap } from '../../hooks/lists'
import NewDemo from '../../assets/newDemo.png'

const BAD_IMAGES = {}

const Inline = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
`

const Image = styled.img`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  background-color: white;
  border-radius: 50%;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.075);
`

const StyledEthereumLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > img {
    width: ${({ size }) => size};
    height: ${({ size }) => size};
  }
`

export default function TokenLogo({ address, header = false, size = '24px', ...rest }) {
  const [error, setError] = useState(false)

  useEffect(() => {
    setError(false)
  }, [address])

  if (error || BAD_IMAGES[address]) {
    return (
      <Inline>
        <img
          {...rest}
          src={NewDemo}
          style={{
            width: size,
            fontSize: size,
          }}
          alt=""
        />
        {/* <span {...rest} alt={''} style={{ fontSize: size }} role="img" aria-label="face">
          🤔
        </span> */}
      </Inline>
    )
  }

  // hard coded fixes for trust wallet api issues
  if (address?.toLowerCase() === '0x5e74c9036fb86bd7ecdcb084a0673efc32ea31cb') {
    address = '0x42456d7084eacf4083f1140d3229471bba2949a8'
  }

  if (address?.toLowerCase() === '0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f') {
    address = '0xc011a72400e58ecd99ee497cf89e3775d4bd732f'
  }

  if (address?.toLowerCase() === WETH[usedChain]) {
    return (
      <StyledEthereumLogo size={size} {...rest}>
        <img
          src={EthereumLogo}
          style={{
            boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.075)',
            borderRadius: '24px',
          }}
          alt=""
        />
      </StyledEthereumLogo>
    )
  }

  const path = `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/assets/${isAddress(
    address
  )}/logo.png`

  const TRANSFORMED_DEFAULT_TOKEN_LIST = listToTokenMap(DEFAULT_TOKEN_LIST)

  return (
    <Inline>
      <Image
        {...rest}
        alt={''}
        src={TRANSFORMED_DEFAULT_TOKEN_LIST[usedChain][isAddress(address)]?.token?.tokenInfo?.logoURI || path}
        size={size}
        onError={(event) => {
          BAD_IMAGES[address] = true
          setError(true)
          event.preventDefault()
        }}
      />
    </Inline>
  )
}
